<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

// Míos / Sin asignar / Todos as the segmented control of the CrmB inbox:
// grey track, white active segment with a soft shadow, teal count.
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="flex gap-1.5 p-[3px] mx-4 mt-3 rounded-lg bg-n-alpha-2">
    <button
      v-for="(item, index) in items"
      :key="item.key"
      type="button"
      class="flex items-center justify-center flex-1 gap-1.5 h-7 rounded-md text-[12.5px] transition-colors"
      :class="
        item.key === activeTab
          ? 'bg-n-solid-2 text-n-slate-12 font-semibold shadow-[0_1px_2px_rgba(20,40,60,.1)]'
          : 'text-n-slate-11 font-medium hover:text-n-slate-12'
      "
      @click="onTabChange(index)"
    >
      <span>{{ item.name }}</span>
      <span
        v-if="item.count !== undefined"
        class="text-[10.5px] font-semibold tabular-nums"
        :class="item.key === activeTab ? 'text-n-blue-text' : 'text-n-slate-9'"
      >
        {{ item.count }}
      </span>
    </button>
  </div>
</template>
